const ReactAppStage = process.env.REACT_APP_API_STAGE;

const getApiEndpointUrl = () => {
  if (ReactAppStage == "Live") {
    return process.env.REACT_APP_API_BASE_URL_LIVE;
  } else {
    return process.env.REACT_APP_API_BASE_URL_TEST;
  }
};
const getApiDomain = () => {
  if (ReactAppStage == "Live") {
    return process.env.REACT_APP_API_DOMAIN_LIVE;
  } else {
    return process.env.REACT_APP_API_DOMAIN_TEST;
  }
};

const dev = {
  API_ENDPOINT_URL: getApiEndpointUrl(),
  API_DOMAIN: getApiDomain(),
};

const prod = {
  API_ENDPOINT_URL: getApiEndpointUrl(),
  API_DOMAIN: getApiDomain(),
};

const test = {
  API_ENDPOINT_URL: getApiEndpointUrl(),
  API_DOMAIN: getApiDomain(),
};

// const dev = {
//   API_ENDPOINT_URL: 'https://vivifiapitest.riolabz.com/api/v1/',
//   API_DOMAIN: 'https://vivifiapitest.riolabz.com'
// };

// const prod = {
//   API_ENDPOINT_URL: 'https://vivifiapitest.riolabz.com/api/v1/',
//   API_DOMAIN: 'https://vivifiapitest.riolabz.com'
// };

// const test = {
//   API_ENDPOINT_URL: 'https://vivifiapitest.riolabz.com/api/v1/',
//   API_DOMAIN: 'https://vivifiapitest.riolabz.com'
// };

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
